import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import SpecialMenuLayout from "@/components/menu-management/special-menu/special-menu-layout";
import { Card } from "@/components/ui/card";
import { TabsList, Tabs, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@/components/ui/separator";
import DishOfDayDraftList from "./dish-of-day/tabs/draft-list";
import DishOfTheDayTabs from "./dish-of-day/tabs/dish-of-the-day-tabs";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import SpecialMenuSkeleton from "@/components/skeleton/special-menu-skeleton";
import useAuth from "@/hooks/useAuth";
import {
  fetchAllDishOfTheDays,
  clearDishOfTheDayMessages,
} from "@/redux/slice/menu-manage-slice/special-menu/dish-of-the-day-slice";

function SpecialMenu() {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const { getLoading } = useSelector((state) => state.menuManage.dishTheDay);

  useEffect(() => {
    dispatch(fetchAllDishOfTheDays(user.restaurant_id));
    clearDishOfTheDayMessages();
  }, [user.restaurant_id]);

  if (getLoading) return <SpecialMenuSkeleton links={backofficeLinks} />;
  return (
    <Layout2 LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}>
      <SpecialMenuLayout>
        <Card className="bg-transparent col-span-1 md:col-span-2">
          <Tabs valueKey="special-menu-dish-of-the-day" className="bg-transparent w-full relative" defaultValue="day">
            <Separator className="absolute top-8" />
            <TabsList className="w-[220px]">
              <TabsTrigger className="bg-transparent" value="day">
                Dish of The Day
              </TabsTrigger>
              <TabsTrigger value="draft">Draft List</TabsTrigger>
            </TabsList>
            <DishOfDayDraftList />
            <DishOfTheDayTabs />
          </Tabs>
        </Card>
      </SpecialMenuLayout>
    </Layout2>
  );
}

export default SpecialMenu;
